<template>
  <div class="account-vacancies">
    <div class="account-vacancies__header-toolbar">
      <div class="account-vacancies__title">{{ $tEmployerVacancies('vacancies') }}</div>
      <div class="account-vacancies__header-toolbar-actions">
        <SortRowVacancies
          class="my-vacancies-tabs__sort"
          :sort="sort"
          :sort-list="sortList"
        />
        <router-link-modified :to="{name: 'account-new-vacancy'}"
                              class="my-vacancies-tabs__sort-button base-btn base-btn--blue">
          <BaseSvg name="ico-plus" width="1.2rem" height="1.2rem"/>
          <span class="base-btn__text">{{ $tEmployerVacancies('create_vacancy') }}</span>
        </router-link-modified>
      </div>

      <div class="account-vacancies__available-publications-count">
        <BaseSvg name="ico-publications"/>
        {{ $tEmployerVacancies('available_for_publication') }} <b>{{ availableForPublication }}</b>
      </div>
    </div>

    <SubpagesTabs :routes="tabsRoutes">
      <transition
        name="fade"
        mode="out-in"
      >
        <router-view
          :key="receivedResumesCount"
          :sort="sort"
          @show-vacancy="onShowOneVacancy"
        />
      </transition>
    </SubpagesTabs>
  </div>
</template>

<script>
  import { mapActions } from 'vuex';
  import SubpagesTabs from '../../../components/SubpagesTabs'
  import SortRowVacancies from "@/components/SortRowVacancies";

  export default {
    name: 'AccountVacanciesPage',
    components: {
      SubpagesTabs,
      SortRowVacancies,
    },
    data() {
      return {
        sortList: [
          'date_desc',
          'date_asc',
          'update_date_desc',
          'update_date_asc',
        ],
        availableForPublication: '-',
      };
    },
    computed: {
      sort() {
        return this.$route.query.order_by || this.sortList[0];
      },
      receivedResumesCount() {
        return this.$store.state.user.receivedResumesCount
      },
      tabsRoutes() {
        return [{
          id: 0,
          name: this.$tEmployerVacancies('vacancies_all'),
          route: this.formNavigationTabRoute('account-vacancies'),
        }, {
          id: 1,
          name: this.$tEmployerVacancies('vacancies_published'),
          route: this.formNavigationTabRoute('account-vacancies-published'),
        }, {
          id: 2,
          name: this.$tEmployerVacancies('vacancies_hidden'),
          route: this.formNavigationTabRoute('account-vacancies-hidden'),
        // }, {
        //   id: 3,
        //   name: this.$tEmployerVacancies('vacancies_archived'),
        //   route: {name: 'account-vacancies-archive'}
        }]
      },
    },
    created() {
      this.loadAvailableForPublication();
    },
    methods: {
      ...mapActions('vacancies', [
        'getAvailableForPublication',
      ]),

      async loadAvailableForPublication() {
        const data = await this.getAvailableForPublication().catch(() => {});
        if (data) {
          this.availableForPublication = data;
        }
      },
      formNavigationTabRoute(routeName) {
        return { name: routeName, query: { ...this.$route.query } };
      },
      onShowOneVacancy() {
        if (this.availableForPublication < 1) return;
        this.availableForPublication--;
      },
    },
  }
</script>
